import { render } from "./Xmditu.vue?vue&type=template&id=4f60dbff&scoped=true"
import script from "./Xmditu.vue?vue&type=script&lang=js"
export * from "./Xmditu.vue?vue&type=script&lang=js"

import "./Xmditu.vue?vue&type=style&index=0&id=4f60dbff&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f60dbff"]])

export default __exports__